import { Compass, Lightbulb, ListChecks, Megaphone, MessagesSquare, MousePointerClick, Sparkles, Tag, type IconComponent } from '@digital-twins/design-system/icons'
import type { StudySpecGoalId } from '@digital-twins/shared-types/questionnaire/study-spec'

/** The existing goal glyphs, shared by creation, research, citations and recents. */
export const STUDY_GOAL_ICONS: Record<StudySpecGoalId, IconComponent> = {
  explore: Compass,
  lp_conversion: MousePointerClick,
  ad_creative: Megaphone,
  concept_validation: Lightbulb,
  pricing_packaging: Tag,
  brand_perception: Sparkles,
  claim_validation: MessagesSquare,
  pain_ranking: ListChecks,
}
